// Interactive overview of combinations of electoral systems & quota types
import data from "../json/interactive-eqc-data.json";

jQuery(function ($) {
  if (!$("body").hasClass("interactive-eqc-page")) {
    return;
  }
  console.log("Interactive EQC ready");

  $(".categoryChoices--item").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("selected");
  });

  $(".checkAll").on("click", function (e) {
    const elm = $(this);
    const isChecked = elm.is(":checked");
    const category = elm.data("cat");
    const categoryChoices = $(`.choices--${category}`);

    if (isChecked) {
      categoryChoices.addClass("selected");
    } else {
      categoryChoices.removeClass("selected");
    }
  });

  const resultsContainer = $("#resultsContainer");
  $("#resultsToggle").on("click", function (e) {
    checkSelected();
  });

  function checkSelected() {
    resultsContainer.empty();

    const selectedItems = $(".categoryChoices--item.selected");
    const results = [];

    const quota = selectedItems.filter(function () {
      return $(this).data("cat") === "qt";
    });

    const electoral = selectedItems.filter(function () {
      return $(this).data("cat") === "es";
    });

    for (var i = 0; i < quota.length; i++) {
      for (var j = 0; j < electoral.length; j++) {
        const quotaChoice = $(quota[i]);
        const electoralChoice = $(electoral[j]);
        results.push({
          combo: quotaChoice.data("index") + electoralChoice.data("index"),
          quotaTitle: quotaChoice.text(),
          electoralTitle: electoralChoice.text(),
        });
      }
    }

    if (results.length > 0) {
      resultsContainer.append(
        '<div class="resultList grid sm:grid-cols-2 gap-4 sm:gap-8"></div>'
      );

      results.forEach((result) => {
        const { combo, quotaTitle, electoralTitle } = result;

        // Loop through each color category in the json object
        for (const color in data) {
          if (data[color].hasOwnProperty(combo)) {
            const text = data[color][combo];

            resultsContainer.find(".resultList")
              .append(`<div class="result-item rounded sm:rounded-md overflow-hidden type-${color} border" data-combo="${combo}">
              <div class="result-item--title p-2 sm:p-4 font-semibold leading-snug">${quotaTitle} + ${electoralTitle}</div>
              <div class="p-2 sm:p-4 text-mobileS md:text-desktopS">${text}</div>
            </div>`);
            break; // Exit the loop once the matching combo is found
          }
        }
      });

      $("html,body").animate(
        {
          scrollTop: resultsContainer.offset().top - 32,
        },
        1000
      );
    } else {
      resultsContainer.append(
        '<p class="text-red-500 text-mobileS md:text-desktopS font-semibold">Please select at least one item from each category to proceed.</p>'
      );
    }
  }
});
